export default __webpack_public_path__ + "static/media/minimalistV2-desktop.2d44c41f.jpg";